import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { changeVideoCompressorField } from '../../Redux/Actions/ToolActions';
import { useDispatch, useSelector } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FileUploader } from 'react-drag-drop-files';
import {
	validateURL,
} from '../../utilies/api-vc';
import uuid from 'react-uuid';
import UploadingVideoProgress from './UploadingVideoProgress';
const fileTypes = ['mov', 'mp4', 'webm'];
// "asf", "flac", "flv", "gif", "m4v", "mkv", "webm", "wmv"
const VideoDragDropUploader = ({ shortcodeSettings, onSuccessUpload }) => {
	const dispatch = useDispatch();
	const VideoStateReducer = useSelector(
		(state) => state.VideoCompresserReducer
	);
	const [errorMessage, setErrorMessage] = useState('');
	const [showdrag, setShowDrag] = useState(false);
	const [showImageMessage, setShowImageMessage] = useState('');
	const { videoCompresorField } = VideoStateReducer;
	const [showImageError, setShowImageError] = useState(false);
	const [openModel, setOpenModel] = useState(false);


	const [videoSize, setVideoSize] = useState(null);
	const [videoResolution, setVideoResolution] = useState(null);
	const [videoWidth, setVideoWidth] = useState(null);
	const [videoHeight, setVideoHeight] = useState(null);
	const [videoLength, setVideoLength] = useState(null);
	const [fileName, setFileName] = useState(null);
	const [fileNameWithoutExtension, setFileNameWithoutExtension] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		dispatch(
			changeVideoCompressorField({
				shortcodeSettings1: shortcodeSettings,
			})
		);
	}, []);

	useEffect(() => {
		$('.paste-url-sec').click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			setOpenModel(true);
			return false;
		});
	}, [videoCompresorField.step]);

	const handleChangeModelUrl = (e) => {
		dispatch(
			changeVideoCompressorField({ VideoUrlInput: e.target.value })
		);
		if (e.target.value) {
			var res = e.target.value.match(
				/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
			);
			if (res == null) {
				setErrorMessage('Invalid URL!');
			} else {
				setErrorMessage('');
			}
		} else {
			setErrorMessage('Please enter a URL!');
		}
	};
	const handleModelCancel = () => {
		setOpenModel(false);
	};

	const convertImageLink = () => {
		setErrorMessage('');
		if (!!videoCompresorField.VideoUrlInput) {
			let handleUploadChange = {
				uploadVideoLoader: true,
			};
			dispatch(changeVideoCompressorField(handleUploadChange));
			var res = videoCompresorField.VideoUrlInput.match(
				/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
			);
			if (res == null) {
				setErrorMessage('Invalid URL!');
			} else {
				validateURL(videoCompresorField.VideoUrlInput);
			}
		} else {
			setErrorMessage('Please enter a URL!');
		}
	};

	// Uploads a single chunk (one R2 multipart part). Throws on failure so the
	// parallel orchestrator in handleChange() can stop and surface the error
	// instead of silently proceeding to complete a partial upload.
	const uploadChunk = async (
		chunk,
		index,
		totalChunks,
		unique_id,
		fileName,
		onProgress
	) => {
		const formData = new FormData();
		formData.append('file', chunk);
		formData.append('index', index);
		formData.append('totalChunks', totalChunks);
		formData.append('fileName', fileName);
		formData.append('unique_id', unique_id);
		formData.append('userEmail', 'taejun@vlogr.com');

		const response = await axios.post(
			'https://plugin-shortsmaker.ssemble.com/upload-file',
			formData,
			{
				// Report bytes sent for THIS chunk so the caller can sum live
				// progress across all parallel chunks (smooth bar instead of
				// jumping only when a whole chunk finishes).
				onUploadProgress: (e) => {
					if (onProgress) onProgress(e.loaded || 0);
				},
			}
		);

		// Only the final (completion) chunk returns the assembled file URLs.
		// When it does, advance the flow to the preview/edit step.
		if (
			response.status == 200 &&
			response.data &&
			response.data.videoFileURL &&
			response.data.thumbnailFileURL
		) {
			const uploadedState = {
				validUrlInput: true,
				uploadVideoLoader: false,
				uploadFileData: response,
				videoSize: videoSize,
				videoResolution: videoResolution,
				videoWidth: videoWidth,
				videoHeight: videoHeight,
				videoLength: videoLength,
				fileName: fileName,
				videoTitle: fileName,
				fileNameWithoutExtension: fileNameWithoutExtension,
				message: 'Uploaded....',
				step: 3,
			};
			dispatch(changeVideoCompressorField(uploadedState));
			onSuccessUpload(uploadedState);
		}

		return response;
	};

	// Retry a chunk a couple of times on transient network errors — parallel
	// uploads make transient blips slightly more likely, and one failed part
	// would otherwise fail the whole multipart completion.
	const uploadChunkWithRetry = async (
		chunk,
		index,
		totalChunks,
		unique_id,
		fileName,
		onProgress,
		attempts = 3
	) => {
		let lastErr;
		for (let attempt = 0; attempt < attempts; attempt++) {
			try {
				return await uploadChunk(chunk, index, totalChunks, unique_id, fileName, onProgress);
			} catch (err) {
				lastErr = err;
				// A retry re-sends this chunk from 0 — reset its counted bytes so
				// the summed total doesn't double-count the partial first attempt.
				if (onProgress) onProgress(0);
				await new Promise((r) => setTimeout(r, 500 * (attempt + 1)));
			}
		}
		throw lastErr;
	};

	const handleChange = async (file) => {
		if (file.length < 2) {

			// check the resolutions and other metas before upload
			if (file) {
				const videoFile = file[0];
				const videoSizeInBytes = videoFile.size;
				const videoSizeInMB = (videoSizeInBytes / (1024 * 1024)).toFixed(2);
				console.log("videoSizeInMB::", videoSizeInMB);
				setVideoSize(videoSizeInMB);

				// Create a video element to load the video and retrieve its resolution
				const videoElement = document.createElement('video');
				const videoURL = URL.createObjectURL(videoFile);
				videoElement.src = videoURL;

				// Wait for the video metadata to be loaded
				await new Promise((resolve) => {
					videoElement.addEventListener('loadedmetadata', resolve);
				});

				console.log("videoElement data", videoElement);

				const videoWidth = videoElement.videoWidth;
				setVideoWidth(videoWidth);
				const videoHeight = videoElement.videoHeight;
				setVideoHeight(videoHeight);
				console.log("videoWidth -- videoHeight", videoWidth, videoHeight);

				setVideoResolution(`${videoWidth}x${videoHeight}`);

				const videoDuration = videoElement.duration;
				setVideoLength(videoDuration);

				if (videoDuration < 50) {
					setError('We do not support videos under 1 minute.');
					setShowImageError(true);
					setShowImageMessage('We do not support videos under 1 minute.');
					return;
				} else {
					setShowImageError(false);
				}


				// Clean up the video element and URL
				URL.revokeObjectURL(videoURL);

				// Get the file name with extension
				const name = videoFile.name;
				setFileName(name);

				// Get the file name without extension
				const nameWithoutExtension = name.substring(0, name.lastIndexOf('.'));
				setFileNameWithoutExtension(nameWithoutExtension);

			}


			setShowImageError(false);

			const handleUploadChange = {
				step: 2,
			};
			dispatch(changeVideoCompressorField(handleUploadChange));
			try {
				// 5 MiB is the R2/S3 multipart minimum part size for every part
				// except the last — do NOT lower this or CompleteMultipartUpload
				// will reject the upload.
				const CHUNK_SIZE = 5 * 1024 * 1024;
				const fileObj = file[0];
				const totalBytes = fileObj.size || 1;
				const totalChunks = Math.ceil(fileObj.size / CHUNK_SIZE);
				const unique_id = uuid();
				const sliceChunk = (i) =>
					fileObj.slice(i * CHUNK_SIZE, Math.min((i + 1) * CHUNK_SIZE, fileObj.size));

				// Smooth, byte-level progress: track bytes sent per chunk (chunks
				// upload in parallel), sum them, and show total / file size. Cap at
				// 98% while bytes are still flowing so the bar doesn't sit at 100%
				// during the server-side finalize (complete + ffprobe + thumbnail);
				// the completion response flips it to done. lastPercent keeps the
				// bar monotonic so a retry (which resets a chunk to 0) can't rewind.
				const loadedByChunk = {};
				let lastPercent = 0;
				const reportProgress = (index, loaded) => {
					loadedByChunk[index] = loaded;
					let sum = 0;
					for (const k in loadedByChunk) sum += loadedByChunk[k];
					const pct = Math.min(98, Math.floor((sum / totalBytes) * 100));
					if (pct > lastPercent) {
						lastPercent = pct;
						dispatch(changeVideoCompressorField({ uploadProgress: pct }));
					}
				};

				// Upload all chunks EXCEPT the completion (last) chunk in parallel
				// with bounded concurrency. The backend streams each chunk straight
				// to R2 as an order-independent multipart part, so parallel uploads
				// are safe and roughly N× faster than the old sequential loop.
				// The last chunk triggers CompleteMultipartUpload on the server, so
				// it must be sent only AFTER every other part is durably recorded.
				const lastIndex = totalChunks - 1;
				const CONCURRENCY = 4;
				let nextIndex = 0;
				const worker = async () => {
					while (true) {
						const i = nextIndex++;
						if (i >= lastIndex) break;
						await uploadChunkWithRetry(sliceChunk(i), i, totalChunks, unique_id, fileObj.name,
							(loaded) => reportProgress(i, loaded));
						// Pin this chunk to its full size in case the final progress
						// event didn't fire (keeps the sum accurate).
						reportProgress(i, sliceChunk(i).size);
					}
				};
				await Promise.all(
					Array.from({ length: Math.min(CONCURRENCY, Math.max(1, lastIndex)) }, worker)
				);

				// Completion chunk (also covers the single-chunk case where
				// lastIndex === 0 and the parallel phase uploaded nothing).
				await uploadChunkWithRetry(
					sliceChunk(lastIndex),
					lastIndex,
					totalChunks,
					unique_id,
					fileObj.name,
					(loaded) => reportProgress(lastIndex, loaded)
				);
				dispatch(changeVideoCompressorField({ uploadProgress: 100 }));
			} catch (ex) {
				setShowImageError(true);
				setShowImageMessage('Error While Uploading file.');
				dispatch(changeVideoCompressorField({ step: 1 }));
			}
		} else {
			setShowImageError(true);
			setShowImageMessage('Multiple file upload is not allowed');
			// alert(showImageError)
		}
	};
	const handleDrop = (dragging) => {
		// setShowImageError(false)
		setShowDrag(dragging);
	};
	const handleSizeError = () => {
		setShowImageError(true);
		setShowImageMessage("Videos over 100MB can't be uploaded.");
	};
	const handleTypeError = (err) => {
		setShowImageError(true);
		setShowImageMessage('This file type is not supported.');
	};

	return (
		<div className="bg_remover-wrapper ss_custom_dragDrop">
			{videoCompresorField.step == 1 || videoCompresorField.step == 3 ? (
				<FileUploader
					classes="drop_area drop_zone ss_drop_zone"
					handleChange={handleChange}
					maxSize={100}
					multiple={true}
					name="fileType"
					types={fileTypes}
					hoverTitle=""
					onSizeError={handleSizeError}
					onTypeError={handleTypeError}
					onDraggingStateChange={handleDrop}
					dropMessageStyle={{ "backgroundColor": '#3782F7', "border": '2px solid #3782F7' }}
				>
					<section
						className={
							showImageError
								? 'video-compressor-sec tools-sec during-drap-video  during-drap-video-error'
								: !!showdrag
									? 'video-compressor-sec tools-sec during-drap-video'
									: 'video-compressor-sec tools-sec '
						}
					>
						{!!showImageError && (
							<div className="video-not-support">
								{showImageMessage}
							</div>
						)}
						<div className="container">
							<div className="video-comp-con">
								<form>
									<div className="drag-drop-text">
										Choose a file (MP4, MOV, WEBM) or Drag it here
									</div>
								</form>
							</div>
						</div>
					</section>
				</FileUploader>
			) : videoCompresorField.step == 2 ? (
				<UploadingVideoProgress
					videoCompresorField={videoCompresorField} shortcodeSettings={shortcodeSettings}
				/>
			) : (
				''
			)}

			<Modal
				show={openModel}
				onHide={handleModelCancel}
				backdrop="static"
				keyboard={false}
				className="paste_url-modal"
			>
				<Modal.Body>
					<div
						title="Back"
						onClick={handleModelCancel}
						className="tools-back"
					>
						<h4>Back</h4>
					</div>
					<div className="enter-url-popup-con">
						<h4>Please enter a URL</h4>
						<div className="input-group">
							<input
								className={
									!!errorMessage ? 'error-message' : ''
								}
								type="url"
								id
								name
								placeholder="Enter URL"
								value={videoCompresorField.VideoUrlInput}
								onChange={handleChangeModelUrl}
							/>
						</div>
						{errorMessage ? (
							<span
								style={{ fontWeight: 'bold', color: 'red' }}
							>
								{errorMessage}
							</span>
						) : (
							''
						)}
						<div className="create-account-btn">
							<button
								className="vcompresoor_convertButtonIsClicked"
								type="button"
								disabled={
									!!videoCompresorField.uploadVideoLoader
										? true
										: false
								}
								onClick={() => convertImageLink()}
								title="Upload"
							>
								Upload
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	);
};
export default VideoDragDropUploader;
